// created to avoid circular dependencies

export const TEMPLATE_LABEL = 'template';

export const MESSAGE = 'note_message';
export const NOTE_TEMPLATE_ID = 'note_template_id';
export const NO_TEMPLATE = 'no_template';
export const EMAIL_MESSAGE = 'email_message';
export const EMAIL_SUBJECT = 'email_subject';
export const EMAIL_TEMPLATE_ID = 'email_template_id';
export const RECEIVER_EMAIL = 'receiver_email';
export const DIGITAL_GIFT_NAMES = 'digital_gift_names';
export const DEPARTMENT_IDS = 'department_ids';
export const TITLE = 'title';
export const BODY = 'body';
export const SUBJECT = 'subject';
export const TYPE = 'type';
export const IS_DEFAULT = 'is_default';
export const TEMPLATE_TYPE = 'templateType';
export const COVER_IMAGE = 'coverImageUrl';
export const GLOBAL_APP_BAR_LOGO_IMAGE = 'globalLogoImageUrl';
export const GLOBAL_HEADER_MEDIA = 'globalHeaderMediaUrl';
export const GLOBAL_HERO_SECTION_IMAGE = 'globalHeroSectionImageUrl';
